<template>
    <div class="crm-table">
        <el-table
            ref="TTable"
            :data="state.tableData"
            :class="{
                cursor: isCopy,
                highlightCurrentRow: highlightCurrentRow,
                radioStyle: table.firstColumn && table.firstColumn.type === 'radio'
            }"
            v-bind="$attrs"
            size="default"
            :highlight-current-row="highlightCurrentRow"
            :border="table.border || isTableBorder"
            :cell-class-name="cellClassNameFuc"
            :height="table.maxHeight || tableHeight"
            :tooltip-effect="table.tooltipEffect || 'light'"
            :row-key="rowKey"
            :tooltip-options="tooltipOption"
            @cell-dblclick="cellDblclick"
            @row-click="rowClick"
        >
            <!-- 复选框 -->
            <el-table-column
                v-if="table.firstColumn.type === 'selection'"
                :type="table.firstColumn.type"
                :width="table.firstColumn.width || 55"
                :reserve-selection="table.firstColumn.isPaging || false"
                :label="table.firstColumn.label"
                :align="table.firstColumn.align || 'center'"
                :fixed="table.firstColumn.fixed"
                v-bind="$attrs"
            />
            <!-- 单选框 -->
            <el-table-column
                v-if="table.firstColumn.type === 'radio'"
                :type="table.firstColumn.type"
                :width="table.firstColumn.width || 50"
                :label="table.firstColumn.label"
                :fixed="table.firstColumn.fixed"
                :align="table.firstColumn.align || 'center'"
            >
                <template #default="scope">
                    <el-radio
                        v-model="radioVal"
                        :label="scope.$index + 1"
                        @click.prevent="radioChange(scope.row, scope.$index + 1)"
                    />
                </template>
            </el-table-column>
            <!-- 序列号 -->
            <el-table-column
                v-if="table.firstColumn.type === 'index'"
                :type="table.firstColumn.type"
                :width="table.firstColumn.width || 50"
                :label="table.firstColumn.label || '序列'"
                :fixed="table.firstColumn.fixed"
                :align="table.firstColumn.align || 'center'"
                v-bind="$attrs"
            >
                <template #default="scope">
                    <span>
                        {{
                            isShowPagination
                                ? (table.currentPage - 1) * table.pageSize + scope.$index + 1
                                : scope.$index + 1
                        }}
                    </span>
                </template>
            </el-table-column>
            <!-- 主体内容 -->
            <template #empty>
                <no-data />
            </template>
            <template v-for="(item, index) in renderColumns">
                <template v-if="!item.children">
                    <!-- 常规列 -->
                    <el-table-column
                        v-if="item.isShowCol === false ? item.isShowCol : true"
                        :key="item.prop"
                        :type="item.type"
                        :label="item.label"
                        :prop="item.prop"
                        :width="item.width"
                        :min-width="item['min-width'] || (item.minWidth && getColumnWidth(item.minWidth))"
                        :sortable="item.sort || sortable"
                        :align="item.align || 'left'"
                        :fixed="item.fixed"
                        :show-overflow-tooltip="item.noShowTip === false ? item.noShowTip : true"
                        :class-name="item.className"
                        v-bind="{...item.bind, ...$attrs}"
                    >
                        <template #header>
                            <render-header
                                v-if="item.renderHeader"
                                :column="item"
                                :render="item.renderHeader"
                            />
                            <component
                                :is="item.headerComponent"
                                v-if="item.headerComponentName"
                                :column="item"
                            />
                            <el-tooltip
                                v-if="item.tooltipTitle || item.icon"
                                placement="bottom"
                                effect="light"
                                :show-arrow="false"
                            >
                                <template #content>
                                    <h3
                                        v-if="item.tooltipTitle"
                                        class="tooltipTitle"
                                    >
                                        {{ $t(item.tooltipTitle) }}
                                    </h3>
                                    <div
                                        v-for="(tip, idx) in item.tooltipList"
                                        :key="idx"
                                        style="color: #606266; maxwidth: 400px"
                                    >
                                        <!--bca-disable-->
                                        <div v-html="$t(tip)"></div>
                                        <!--bca-disable-->
                                    </div>
                                </template>
                                <img
                                    v-if="item.icon"
                                    src="@/assets/images/tip.png"
                                    style="width: 14px; cursor: pointer"
                                >
                            </el-tooltip>
                        </template>
                        <template #default="scope">
                            <!-- render渲染 -->
                            <template v-if="item.render">
                                <!-- 可点击跳转的自定义组件 -->
                                <component
                                    :is="item.component"
                                    v-if="item.render()"
                                    :column="item"
                                    :row="scope.row"
                                    :index="scope.$index"
                                    @handle-search-more="handleSearchMore"
                                    @handle-click="handleClick"
                                />

                                <render-col
                                    v-else
                                    :column="item"
                                    :row="scope.row"
                                    :render="item.render"
                                    :index="scope.$index"
                                />
                            </template>
                            <div v-else>
                                <span
                                    v-if="!item.format"
                                    :style="{color: item.color}"
                                >
                                    <el-icon v-if="item.contextIcon">
                                        <component :is="item.contextIcon" />
                                    </el-icon>
                                    {{ item.prefix || ''
                                    }}{{
                                        scope.row[item.aliasProp] ||
                                            /*bca-disable*/
                                            (needDataTranslate
                                                ? $t(scope.row[item.prop])
                                                : renderDefaultValue(scope.row[item.prop]))
                                            /*bca-disable*/
                                    }}{{ item.suffix || '' }}
                                </span>
                                <!-- 自定义数据格式 -->
                                <!--bca-disable-->
                                <div
                                    v-else
                                    v-html="item['format'](scope.row, i18n.t)"
                                ></div>
                                <!--bca-disable-->
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <!-- 表头合并单元格 -->
                <t-table-column
                    v-else
                    :key="index + 'm'"
                    :item="item"
                />
            </template>
            <slot></slot>
            <!-- 操作按钮 -->
            <el-table-column
                v-if="table.operator"
                :fixed="table.operatorConfig && table.operatorConfig.fixed"
                :label="(table.operatorConfig?.label && $t(table.operatorConfig.label)) || $t('btn.operation')"
                :width="(table.operatorConfig && (table.operatorConfig.width || table.operatorConfig.minWidth)) || 100"
                :align="(table.operatorConfig && table.operatorConfig.align) || 'left'"
                class-name="operator"
            >
                <template #default="scope">
                    <component
                        :is="table.operator[0]?.component"
                        v-if="table.operator[0]?.componentName"
                        :row="scope.row"
                        @handleclick="handleClick"
                    />
                    <div
                        v-else
                        class="operator_btn"
                        :style="table.operatorConfig && table.operatorConfig.style"
                    >
                        <el-tooltip
                            v-for="(item, index) in table.operator"
                            :key="index"
                            effect="light"
                            :content="item.tooltip"
                            placement="bottom"
                            :disabled="!item.tooltip"
                            :show-after="800"
                            :show-arrow="false"
                        >
                            <el-button
                                v-show="checkIsShow(scope, item)"
                                class="table-button"
                                :type="item.type"
                                :text="!item.isButton"
                                :style="item.style"
                                :disabled="item.disabled"
                                :loading="item.loading"
                                size="small"
                                @click="item.fun && item.fun(scope.row, scope.$index, state.tableData)"
                            >
                                <!-- render渲染 -->
                                <template v-if="item.render">
                                    <render-col
                                        :column="item"
                                        :row="scope.row"
                                        :render="item.render"
                                        :index="scope.$index"
                                    />
                                </template>
                                <span v-if="!item.render && item.text">{{ $t(item.text) }}</span>
                                <svg-icon
                                    v-if="item.icon"
                                    class-name="table-icon-style"
                                    :icon-class="item.icon"
                                />
                                <div
                                    v-if="item.url"
                                    :style="{backgroundImage: `url(${chooseImg(item.url)})`}"
                                    :class="`img-container ${item.url}`"
                                ></div>
                            </el-button>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <my-pagination
            v-if="state.tableData && state.tableData.length && isShowPagination"
            small
            :current-page="table.currentPage"
            :page-sizes="table.pageSizes || [20, 50, 100]"
            :default-page-size="20"
            :page-size="table.pageSize"
            :layout="paginationLayout"
            :total="table.total"
            v-bind="$attrs"
            background
            @current-change="handlesCurrentChange"
            @size-change="handleSizeChange"
        />
    </div>
</template>
<script lang="ts">
export default {
    name: 'BTable'
};
</script>
<script setup lang="ts">
import {computed, ref, watch, useSlots, reactive, nextTick} from 'vue';
import {ElMessage} from 'element-plus';
// import store from '@/store'
// import SingleEditCell from './singleEditCell.vue'
import MyPagination from '@/components/pagination';
import RenderCol from './renderCol.vue';
import RenderHeader from './renderHeader.vue';
import TTableColumn from './TTableColumn.vue';
import {useI18n} from 'vue-i18n';
import useClipboard from 'vue-clipboard3';
import NoData from '@/components/noData/index.vue';
import {renderDefaultValue} from '@/utils/common';
import {useFullScreenTableHeight} from '@/hooks/useFullScreenTableHeight';

const i18n = useI18n();
const tooltipOption={
    showArrow: false,
}

const props = defineProps({
    needDataTranslate: {
        type: Boolean,
        default: false
    },
    // table所需数据
    table: {
        type: Object,
        default: () => {
            return {};
        },
        required: true
    },
    // 表头数据
    columns: {
        type: Array,
        default: () => {
            return [];
        }
        // required: true
    },
    // 表格标题
    title: {
        type: String,
        default: ''
    },
    // 是否复制单元格
    isCopy: {
        type: Boolean,
        default: true
    },
    // 是否开启点击整行选中单选框
    rowClickRadio: {
        type: Boolean,
        default: true
    },
    // 是否显示分页
    isShowPagination: {
        type: Boolean,
        default: true
    },
    // 是否高亮选中行
    highlightCurrentRow: {
        type: Boolean,
        default: false
    },
    // 是否开启合计行隐藏复选框/单选框/序列
    isTableColumnHidden: {
        type: Boolean,
        default: false
    },
    // 如果设置为 'custom'，则代表用户希望远程排序，需要监听 Table 的 sort-change 事件
    sortable: {
        type: [Boolean, String]
    },
    rowKey: {
        type: String || Function || Number,
        default: 'id'
    },
    paginationLayout: {
        type: String,
        default: 'total, sizes, prev, pager, next, jumper'
    }
});
// 初始化数据
const state = reactive({
    tableData: props.table.data,
    columnSet: []
});

// 单选框
const radioVal = ref(null);
// 判断单选选中及取消选中
const forbidden = ref(true);
// 获取ref
const TTable: any = ref<HTMLElement | null>(null);
// 抛出事件
const emits = defineEmits([
    'save',
    'page-change',
    'handleEvent',
    'radioChange',
    'handleSearchMore',
    'handleClick',
    'page-size-change'
]);
// 获取所有插槽
const slots = useSlots();
const {tableHeight} = useFullScreenTableHeight();

const summaryIsAddEvent = ref(false);
watch(
    () => props.table.data,
    (val) => {
        state.tableData = val;
        nextTick(() => {
            if (val.length && !summaryIsAddEvent.value) {
                summaryIsAddEvent.value = true;
                showSummaryPopup();
            }
        });
    },
    {deep: true}
);
// 按钮权限
// const btnPremissions = computed(() => {
//   // return store.getters.permissions
//   // return store.getters.permissions
// })
// 过滤字典
/**
 * 下拉数据回显中文过滤器
 * @param [String,Number] value 需要转中文的key值
 * @param {String} list  数据源
 * @param [String,Number] key  数据源的key字段（默认：value）
 * @param {String} label  数据源的label字段（默认：label）
 */
type Value = string | number;
const constantEscape = (value: Value, list: string[], key: Value, label: string) => {
    if (!value) return '';
    const res: any =
        list.find((item: any) => {
            return item[key] === value;
        }) || value;
    return res && (res[label] ? res[label] : res);
};
// 所有列（表头数据）
const renderColumns = computed(() => {
    return state.columnSet.length > 0
        ? state.columnSet.reduce((acc: any, cur: any) => {
            if (!cur.hidden) {
                const columnByProp: any = props.columns.reduce((acc: any, cur: any) => {
                    acc[cur.prop] = cur;
                    return acc;
                }, {});
                acc.push(columnByProp[cur.prop]);
            }
            return acc;
        }, [])
        : props.columns;
});
// 判断如果有表头合并就自动开启单元格缩放
const isTableBorder = computed(() => {
    return renderColumns.value.some((item: any) => item.children);
});
// 合并行隐藏复选框/单选框
const cellClassNameFuc = ({row}: any) => {
    if (!props.isTableColumnHidden) {
        return false;
    }
    if (
        state.tableData.length -
            (state.tableData.length - props.table.pageSize < 0 ? 1 : state.tableData.length - props.table.pageSize) <=
        row.rowIndex
    ) {
        return 'table_column_hidden';
    }
};
// forbidden取值（选择单选或取消单选）
const isForbidden = () => {
    forbidden.value = false;
    setTimeout(() => {
        forbidden.value = true;
    }, 0);
};
// 单选抛出事件radioChange
const radioClick = (row: any, index: any) => {
    forbidden.value = !!forbidden.value;
    if (radioVal.value) {
        if (radioVal.value === index) {
            radioVal.value = null;
            isForbidden();
            // 取消勾选就把回传数据清除
            emits('radioChange', null, radioVal.value);
        } else {
            isForbidden();
            radioVal.value = index;
            emits('radioChange', row, radioVal.value);
        }
    } else {
        isForbidden();
        radioVal.value = index;
        emits('radioChange', row, radioVal.value);
    }
};
// 点击单选框单元格触发事件
const radioChange = (row: any, index: number) => {
    radioClick(row, index);
};
// 点击某行事件
const rowClick = (row: any) => {
    if (props.rowClickRadio) {
        radioClick(row, props.table.data.indexOf(row) + 1);
    }
};
// 获取复制的方法
const {toClipboard} = useClipboard();
const copyContent = async (text: string) => {
    text = text + '';
    try {
        // clipboard api在http协议下会失效，这里做兼容处理
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
        } else {
            // toClipboard Api传进去的值必须是string类型
            await toClipboard(text);
        }
        ElMessage.success('已复制');
    } catch (e) {
        ElMessage.error('复制失败');
    }
};
// 双击复制单元格内容
const cellDblclick = (row: any, column: any) => {
    if (!props.isCopy) {
        return false;
    }
    const copyText = row[column.property];
    copyContent(copyText);
};
// 判断是否使用漏了某个插槽
const isShow = (name: string) => {
    return Object.keys(slots).includes(name);
};
// 整行编辑返回数据
const save = () => {
    emits('save', state.tableData);
    return state.tableData;
};
// 是否显示表格操作按钮
const checkIsShow = (scope: any, item: any) => {
    let isNoshow = false;
    if (item.noshow) {
        // 双重判断
        item.noshow.map((rs: any) => {
            rs.isShow =
                typeof rs.val === 'string'
                    ? rs.val === 'isHasVal'
                        ? scope.row[rs.key]
                            ? 'true'
                            : 'false'
                        : 'true'
                    : rs.val.includes(scope.row[rs.key])
                        ? 'false'
                        : 'true';
        });
        isNoshow = item.noshow.every((key: any) => {
            return key.isShow === 'true';
        });
    } else {
        isNoshow = true;
    }
    // 单独判断
    const isShow = !item.show || item.show.val.includes(scope.row[item.show.key]);
    // 按钮权限
    // let isPermission = item.hasPermi ? btnPremissions.value.includes(item.hasPermi) : true
    // table页面合计
    const totalTxt = Object.values(scope.row).every((key) => {
        return key !== '当页合计';
    });
    // table页面合计
    const totalTxt1 = Object.values(scope.row).every((key) => {
        return key !== '全部合计';
    });
    return (
        isShow &&
        isNoshow &&
        !scope.row[item.field] &&
        (item.isField ? scope.row[item.isField] : true) &&
        totalTxt &&
        totalTxt1
    );
};
// 单个编辑事件
const handleEvent = (type: any, val: any) => {
    emits('handleEvent', type, val);
};
// 当前页码
const handlesCurrentChange = (val: number) => {
    emits('page-change', val);
};
//当前每页显示条数
const handleSizeChange = (val: number) => {
    emits('page-size-change', val);
};
//点击查看更多
const handleSearchMore = (val: any) => {
    emits('handleSearchMore', val);
};

// 单元格自定义组件内部按钮点击事件
const handleClick = (val: any) => {
    emits('handleClick', val);
};

/**
 * 公共方法
 */
// 清空排序条件
const clearSort = () => {
    return TTable.value.clearSort();
};
// 取消某一项选中项
const toggleRowSelection = (row: any, selected = false) => {
    return TTable.value.toggleRowSelection(row, selected);
};
// 清空复选框
const clearSelection = () => {
    return TTable.value.clearSelection();
};

//选择图片
const chooseImg = (url: string) => {
    return new URL(`/src/assets/images/${url}.png`, import.meta.url).href;
};

// 不同语言不同宽度
const {locale} = useI18n();
const getColumnWidth = (width: any) => {
    return width[locale.value] || width || '';
};
const showSummaryPopup = () => {
    const footerWrapper = document.querySelector('.el-table__footer-wrapper');
    const tbody = footerWrapper?.querySelector('tbody');
    // 获取所有具有 class 为 "cell" 的 div 元素
    const cellDivs = tbody?.querySelectorAll('.cell');
    // 添加鼠标移入事件监听器
    cellDivs?.forEach((cell) => {
        cell.addEventListener('mouseenter', (event: Event) => {
            const target = event.target as HTMLElement;
            if (!target.innerText) return;
            // 分号是换行标识符
            const textList = target!.innerText.split(';');
            const textListLength = textList.length;
            const rect = target!.getBoundingClientRect();
            const top = rect.top;
            const left = rect.left;
            const width = rect.width;
            // 创建新的 div 元素用于显示内容
            const tooltip = document.createElement('div');
            tooltip.className = 'el-table-tooltip';
            tooltip.style.position = 'absolute';
            tooltip.style.left = `${left - 0.5}px`;
            tooltip.style.top = `${top - textListLength * 22.4 - 20}px`;
            tooltip.style.width = `${width + 1}px`;
            tooltip.innerHTML = textList.join('\n');
            // 将 tooltip 添加到 body 元素中
            document.body.appendChild(tooltip);
        });
        // 添加鼠标移出事件监听器
        cell.addEventListener('mouseleave', () => {
            // 移除之前创建的 tooltip
            const tooltip = document.querySelector('.el-table-tooltip');
            if (tooltip) {
                tooltip.remove();
            }
        });
        // 添加双击复制事件
        cell.addEventListener('dblclick', (event: Event) => {
            const target = event.target as HTMLElement;
            copyContent(target.innerText);
        });
    });
};
// 暴露方法出去
defineExpose({clearSelection, toggleRowSelection, clearSort});
</script>

<style lang="scss" scoped>
@import '@/assets/crm-table.scss';
</style>
<style>
body .el-table-tooltip {
    border: 1px solid #ebeef5;
    position: absolute;
    z-index: 9999;
    background-color: rgba(255, 255, 255);
    color: rgba(40, 136, 255, 1);
    font-weight: 400;
    padding: 5px 0px 5px 15px;
    border-radius: 3px;
    font-size: 14px;
    line-height: 1.6;
    white-space: pre; /* 保留换行 */
}
</style>
